import { useBootTrace } from '@/gateway/devtools/bootTrace';

/**
 * Transitional placeholder used while the shell resolves /me, swaps origins,
 * or lazy-loads a remote MF chunk. Renders an invisible block so it keeps the
 * layout slot but never flashes a visible "loading card" during cross-port
 * redirects or route hand-offs.
 */
export function AppSkeleton() {
  useBootTrace('AppSkeleton');
  return <div aria-busy="true" aria-live="polite" className="h-full w-full" />;
}
